import {UserTypeEnum} from "../enums/user-type.enum";
import {UserType} from "../Models/UserType";

export const UserTypes: UserType[] = [
	{
		Id: UserTypeEnum.PARTICULIER,
		USR_TYPE:UserTypeEnum.PARTICULIER,
		Label: 'labelUserTypeParticulier'
	},
	{
		Id: UserTypeEnum.AGENCE_VITRINE,
		USR_TYPE:UserTypeEnum.AGENCE_VITRINE,
		Label: 'labelUserTypeAgenceVitrine'
	},
	{
		Id: UserTypeEnum.AGENT_MANDATAIRE,
		USR_TYPE: UserTypeEnum.AGENT_MANDATAIRE,
		Label: 'labelUserTypeAgentMandataire'
	},
	{
		Id: UserTypeEnum.ENTREPRISE_BATIMENT,
		USR_TYPE: UserTypeEnum.ENTREPRISE_BATIMENT,
		Label: 'labelUserTypeEntrepriseBatiment'
	}
];
